<div
  class="figmaImage">
  <div class="figmaImageContainer">
    <div
      class="uploadedImageWrap show"
      (click)="previewImage()"
      [ngStyle]="{ 'background-image': url ? 'url(' + url + ')' : 'none' }"
      role="button"
      tabindex="0"
    ></div>
  </div>

  <div class="figmaInfo">
    <div class="figmaName">{{ fileName || 'test' }}</div>

    <div class="figmaIcon">
      <img src="assets/images/logos/figma-logo.svg" alt="Figma icon" />
      <span>{{ 'text_figma' | dbText }}</span>
    </div>
  </div>

  <span>
    <span (click)="onCloseClick($event)" class="closeButton" role="button" tabindex="0">
      <i class="db-icon db-icon-close"></i>
    </span>
  </span>
</div>
